import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import axiosRetry from 'axios-retry';

import generateId from 'src/lib/generateId';

export default function createHttpClient(requestorId: string): AxiosInstance {
  const client = axios.create({
    xsrfCookieName: '_csrf_token',
    xsrfHeaderName: 'X-CSRF-Token',
    timeout: 5000,
  });
  client.interceptors.request.use(writeDefaultHeadersMiddleware(requestorId));

  const retries = 3;
  axiosRetry(client, { retries });
  return client;
}

function writeDefaultHeadersMiddleware(requestorId: string): (config: AxiosRequestConfig) => any {
  return function (config: AxiosRequestConfig) {
    if (!config.headers) {
      config.headers = {};
    }

    if (!config.headers[HEADER_CORRELATION_ID]) {
      config.headers[HEADER_CORRELATION_ID] = generateId();
    }
    if (requestorId) {
      config.headers['Gladly-Requestor-Id'] = requestorId;
    }
    return config;
  };
}

export const HEADER_CORRELATION_ID = 'Gladly-Correlation-Id';
